import {
	Card,
	CardHeader,
	CardContent,
	Checkbox,
	FormControl,
	InputLabel,
	ListItemText,
	makeStyles,
	MenuItem,
	Select,
	Typography
} from '@material-ui/core'
import React from 'react'

import { DeletableChip } from '../../Misc/DeletableChip'

const SERVICE_CATEGORIES = ['Daycare & Boarding', 'Bar & Park', 'Home Services', 'Grooming']

const useStyles = makeStyles((theme) => ({
	card: {
		maxWidth: '1245px',
		marginBottom: 16
	},
	chips: {
		display: 'flex',
		flexWrap: 'wrap',
		marginTop: '6px',
		backgroundColor: 'transparent !important'
	},
	chip: {
		marginRight: 4
	},
	fullWidthField: {
		'& .MuiFormControl-root': {
			width: '100%'
		}
	}
}))

const Services = ({ selectedFacility, setCurrent }) => {
	const classes = useStyles()
	const serviceCategories = selectedFacility?.launch?.service_categories || []
	const canEdit = selectedFacility?.active && selectedFacility?.launch

	const updateServiceCategories = (categories) => {
		setCurrent({
			...selectedFacility,
			launch: {
				...(selectedFacility.launch || {}),
				service_categories: categories
			}
		})
	}

	return (
		<Card className={classes.card}>
			<CardHeader title="Services" />
			<CardContent>
				<div className={classes.fullWidthField}>
					<FormControl>
						<InputLabel id="facility-services">Services</InputLabel>
						<Select
							id="facility-services-select"
							variant="filled"
							labelId="facility-services"
							value={serviceCategories}
							disabled={!canEdit}
							multiple
							onChange={(e) => updateServiceCategories(e.target.value)}
							renderValue={() => (
								<div className={classes.chips}>
									{serviceCategories.map((value) => (
										<DeletableChip
											key={value}
											label={value}
											className={classes.chip}
											onDelete={
												canEdit
													? () =>
															updateServiceCategories(
																serviceCategories.filter((serv) => serv !== value)
															)
													: undefined
											}
										/>
									))}
								</div>
							)}>
							{SERVICE_CATEGORIES.map((v) => (
								<MenuItem key={v} value={v}>
									<Checkbox checked={serviceCategories.indexOf(v) > -1} />
									<ListItemText primary={v} />
								</MenuItem>
							))}
						</Select>
					</FormControl>
					{!selectedFacility.launch ? (
						<Typography variant="body2" color="textSecondary" style={{ marginTop: 8 }}>
							Launch settings have not been migrated for this facility yet.
						</Typography>
					) : null}
				</div>
			</CardContent>
		</Card>
	)
}

export default Services
